// Метка «открой чат сразу» в адресе страницы. Кнопка «Поговорить» в блоке
// «уже работают» на нашей главной ведёт на САЙТ клиента — туда, где сотрудник
// реально работает, — и человек идёт говорить с конкретным ботом, а не искать
// пузырь в углу чужого сайта. Метку ставит ссылка, читает виджет.
//
// Чистый модуль (DOM нет) — тестируется в изоляции, как delay.ts.

/** Имя параметра адреса. Наше собственное и узнаваемое: на чужом сайте у нас
 *  нет своего пространства имён, и короткое `chat` рано или поздно столкнулось
 *  бы с параметром хозяина страницы. */
export const TALK_PARAM = 'assiistent';
/** Значение параметра. Пара «ключ=значение», а не голый флаг: параметр без
 *  значения половина CMS и рекламных редиректов выбрасывает по дороге. */
export const TALK_VALUE = 'chat';

/** Просит ли адрес страницы открыть чат.
 *
 *  Хеш (`#assiistent`) для этого не годится: на сайте клиента он принадлежит
 *  его якорям и роутеру SPA, и мы не вправе его занимать. Параметр же виден
 *  ровно нам.
 *
 *  Разбираем терпимо: чужая ссылка приезжает и с лишними параметрами, и в
 *  другом регистре значения, и битой. Всё, что не наша пара, — «не просили».
 *
 *  @param search строка запроса страницы (`window.location.search`).
 *  @return открыть ли чат сразу. */
export function linkAsksForChat(search: unknown): boolean {
  if (typeof search !== 'string' || search === '') return false;

  try {
    return new URLSearchParams(search).get(TALK_PARAM)?.toLowerCase() === TALK_VALUE;
  } catch {
    // Битая строка запроса — не повод ронять виджет на чужой странице.
    return false;
  }
}
